import SelectOption from '@/store/dict/selectOptionDict'
import { fetchHistoryUrl } from '../../func'
import { operateMaxShowLength } from '@/store/dict/config'
// eslint-disable-next-line no-unused-vars
import { h } from 'vue'

const STATUS_TAG_MAP = {
  0: {
    type: 'primary', // 进行中
    name: '进行中',
  },
  1: {
    type: 'success', // 进行中
    name: '成功',
  },
  2: {
    type: 'danger', // 进行中
    name: '失败',
  },
  3: {
    type: 'primary', // 进行中
    name: '部分成功',
  },
}
export const tableColumns = [
  {
    name: 'uploadDate',
    columnProps: {
      label: '上传时间',
      prop: 'uploadDate',

    },
  },
  {
    name: 'createUser',
    columnProps: {
      label: '操作人姓名',
      prop: 'createUser',
    },
  },
  {
    name: 'userAccount',
    columnProps: {
      label: '操作人账号',
      prop: 'userAccount',
    },
  },
  {
    name: 'type',
    columnProps: {
      label: '导入类型',
    },
    getText: ({ row }) => SelectOption.taskType[row.type],
  },
  {
    name: 'fileName',
    columnProps: {
      label: '导入文件',
    },
    render: ({ row }) => {
      if (!row.fileUrl) return '--'
      const docType = row.fileUrl.split('.').pop()
      if (!docType) return '--'
      const fileName = row.fileName || `${SelectOption.taskType[row.type]}${row.uploadDate}.${docType}`
      return <a href={row.fileUrl}>{fileName}</a>
    },
  },
  {
    name: 'state',
    columnProps: {
      label: '导入状态',
    },
    render: ({ row }) => {
      // 0进行中 1成功 2失败 3部分成功
      return <el-tag type={STATUS_TAG_MAP[row.state].type}>{STATUS_TAG_MAP[row.state].name}</el-tag>
    },
  },
  {
    name: 'state',
    columnProps: {
      label: '导入结果',
    },
    render: ({ row }) => {
      // 0进行中 1成功 2失败 3部分成功
      if (row.failureCount === null || row.successCount === null || row.state === 0) return '--'
      return <div class="import-history-box">
        <span class="import-result-span"><i class="icon-success"/>成功导入{ Number(row.successCount) }条</span><br/>
        <span class="import-result-span"><i class="icon-fail"/>导入失败{ Number(row.failureCount) }条</span>
      </div>
    },
  },
  {
    name: 'deptName',
    columnProps: {
      label: '所属部门',
      prop: 'deptName',
    },
  },
  {
    name: 'operate',
    columnProps: {
      label: '错误说明',
      width: 240,
    },
    maxShowLength: operateMaxShowLength,
    getOperateList: ({ row }) => {
      if (row.state === 0 || row.state === 1) {
        return []
      }
      return [
        { name: 'download', label: '下载错误明细', action: () => fetchHistoryUrl(row.taskId) },
      ]
    },
    type: 'operate',
  },
]
